"use client";

import { PersonArmsSpread } from "@phosphor-icons/react/dist/ssr";
import { useMutation } from "@tanstack/react-query";

import Spinner from "@/components/spinner";

import axiosInstance from "@/lib/axios";

import { endImpersonation } from "@ndpco/services";
import { Button } from "@ndpco/ui/components/Button";

const ImpersonationBar = ({ fullName }: { fullName?: string }) => {
  const impersonationMutation = useMutation({
    mutationFn: () => endImpersonation(axiosInstance).then((res) => res.data),
    onSuccess: () => {
      window.location.reload();
    },
  });

  return (
    <div className="group fixed left-4 top-1/2 z-50 text-xs">
      <div className="flex w-12 max-w-64 items-center rounded-full bg-amber-600 p-2 leading-none text-amber-100 shadow-md transition-all duration-200 ease-in-out group-hover:w-screen">
        <div className="group-hover:animate-in group-hover:fade-in invisible flex flex-1 items-center gap-x-2 truncate delay-150 group-hover:visible">
          <Button
            disabled={impersonationMutation.isPending}
            onClick={() => impersonationMutation.mutate()}
            rounded
            size="xs"
            variant="subtle"
          >
            خروج
          </Button>
          <span className="w-full truncate">{fullName}</span>
        </div>
        <span className="flex size-8 shrink-0 items-center justify-center">
          {impersonationMutation.isPending ? <Spinner /> : <PersonArmsSpread className="size-5" />}
        </span>
      </div>
    </div>
  );
};

export default ImpersonationBar;
